import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthenticationService) {}

  canActivate() {
    if (!this.authService.isTokenExpired()) {
      return true;
    }
    window.location.href = environment.domainLoginPortal;
    return false;
  }
}
